import { render, staticRenderFns } from "./RecoverOrphansModal.vue?vue&type=template&id=71416978"
import script from "./RecoverOrphansModal.vue?vue&type=script&lang=ts"
export * from "./RecoverOrphansModal.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports